import type { GlobalConfig } from '../@types/context/global-config.types';
import type { MyPageConfig } from '../@types/context/my-page-config.types';
import type { ProductUnsecuredLoanConfig } from '../@types/context/product-unsecured-loan-config.types';
import type { SiteConfig } from '../@types/context/site-config.types';
import { contactZmartaFiConfig } from './presets/contact-zmarta-fi.config';
import { globalFi } from './presets/global-fi.config';
import { myPageOffersConfig } from './presets/mypage-offers.config';
import { organisationZmartaFiConfig } from './presets/organisation-zmarta-fi.config';
import { serviceTrustpilotAxoConfig } from './presets/service-trustpilot-axo.config';
import { sitePathZmartaFiConfig } from './presets/site-path-zmarta-fi.config';
import { unsecuredLoansBrokerCustomFields } from './presets/unsecured-loans-broker-custom-fields.config';

export const global: GlobalConfig = {
  brand: 'freedomrahoitus.fi',
  ...globalFi,
};

export const site: SiteConfig = {
  domain: 'freedomrahoitus.fi',
  theme: {
    name: 'freedom-finans',
    brand: 'freedom-rahoitus',
  },
  ...sitePathZmartaFiConfig,
  ...organisationZmartaFiConfig,
  ...contactZmartaFiConfig,
  services: {
    trustpilot: {
      ...serviceTrustpilotAxoConfig,
      businessUnitId: '51b3d7f4000064000539cfa8',
    },
    gtm: 'GTM-5S6FDL2R',
    ga: 'G-1QLRT7JZS7',
  },
};

export const productUnsecuredLoan: ProductUnsecuredLoanConfig = {
  fields: unsecuredLoansBrokerCustomFields,
};

export const myPage: MyPageConfig = {
  options: { hasHighCostWarning: false, ...myPageOffersConfig },
};
